import { Box, ButtonBase, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import { useReportHubFilters } from "../ReportHubFilterContext";
import { getReportForEnvironment, getReportKey } from "../reports";
import Text from "../../../theme/text/Text";
import { DropdownBaseV2 } from "../../../theme/dropdowns/Dropdown";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import cx from 'classnames';
import { reportFilterComponentTypes } from "../chartFilterEnums";
import { useMemo } from "react";
import { ReportFilterDropdownFilter } from "./filter/ReportFilterDropdownFilter";
import { ReportFilterBooleanFilter } from "./filter/ReportFilterBooleanFilter";
import { ReportFilterSearchQueryDropdownFilter } from "./filter/ReportFilterSearchQueryDropdownFilter";
import { ReportFilterCountryFilter } from "./filter/ReportFilterCountryFilter";
export const RhFilter = (props) => {
    const { t, ready,i18n } = useTranslation();
    const theme =useTheme();
    const colors= tokens(theme.palette.mode);

    const filtersRegistry = useReportHubFilters();
    const chartOption = getReportForEnvironment(getReportKey(props.currentReport), filtersRegistry.environment);
    const usedFilters = props.currentReport ? Object.keys(props.currentReport.filter || {}) : [];
    const availableFilters = useMemo(() => {
        if (!props.currentReport) return []; 
        if(!props.currentReport.filter) return [];

        const used = Object.keys(props.currentReport.filter);
        return chartOption?.filters.filter(f => !used.includes(f)) || [];
    }, [chartOption?.filters, props.currentReport]);

    return (
        <Box
            className={cx(undefined,{
                'wrap-filters':props.wrapFilters,
            })}
            sx={{
                height:40,

                p:0.5,
                display:"flex",
                justifyContent:"flex-start",
                alignItems:'center',
                gap:1,
                background:theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0],
                border:`1px solid ${colors.grey[100]}`,
                boxShadow:`0px 2px 4px ${colors.grey[200]}`,
                borderRadius:5,

                "@media screen and (max-width: 1024px)" : {
                    flex:1,
                },

                "&.wrap-filters":{
                    flexDirection:'column',
                    height:"unset",
                    p:0,
                    background:"unset",
                    border:"unset",
                    boxShadow:'unset',
                    // flexWrap:"wrap",
                }
            }}
        >
            {usedFilters.map((key, idx) => {
                const filterConfig = typeof filtersRegistry.filters[key] === "function"
                    ? filtersRegistry.filters[key]()
                    : filtersRegistry.filters[key];

                return filterConfig?.componentType === reportFilterComponentTypes.DROPDOWN ? (
                    <ReportFilterDropdownFilter
                        wrapFilters={props.wrapFilters}
                        key={key}
                        fKey={key}
                        currentReport={props.currentReport}
                        setCurrentReport={props.setCurrentReport}
                        filter={props.currentReport?.filter[key]}
                    />
                ) : filterConfig?.componentType === reportFilterComponentTypes.COUNTRIES ? (
                    <ReportFilterCountryFilter
                        wrapFilters={props.wrapFilters}
                        key={key}
                        fKey={key}
                        currentReport={props.currentReport}
                        setCurrentReport={props.setCurrentReport}
                        filter={props.currentReport?.filter[key]}
                    />
                ) : filterConfig?.componentType === reportFilterComponentTypes.SEARCHQUERYDROPDOWN ? (
                    <ReportFilterSearchQueryDropdownFilter
                        wrapFilters={props.wrapFilters}
                        key={key}
                        fKey={key}
                        currentReport={props.currentReport}
                        setCurrentReport={props.setCurrentReport}
                        filter={props.currentReport?.filter[key]}
                    />
                ) :filterConfig?.componentType === reportFilterComponentTypes.BOOLEAN ?
                    <ReportFilterBooleanFilter
                        wrapFilters={props.wrapFilters}
                        key={key}
                        fKey={key}
                        currentReport={props.currentReport}
                        setCurrentReport={props.setCurrentReport}
                        filter={props.currentReport?.filter[key]}
                    />
                : 
                    null
                
            })}

            {usedFilters.length === 0 && !props.wrapFilters &&
                <Text
                    sx={{
                        pl:1.5,
                    }}
                >
                    {t("choose_filter")}
                </Text>
            }
            
            {/* Button to display more possible filters */}
            {availableFilters?.length > 0 &&
                <DropdownBaseV2
                    onChange={(selected) => {
                        const filterKey = availableFilters[selected];

                        const registryItem = typeof filtersRegistry.filters[filterKey] === "function"
                            ? filtersRegistry.filters[filterKey]()
                            : filtersRegistry.filters[filterKey];

                        let value;
                        switch(registryItem?.componentType) {
                            case reportFilterComponentTypes.COUNTRIES:
                            case reportFilterComponentTypes.SEARCHQUERYDROPDOWN:
                            case reportFilterComponentTypes.DROPDOWN:
                                value = [];
                                break;
                            case reportFilterComponentTypes.BOOLEAN:
                                value = [false];
                                break;
                        }
                        props.setCurrentReport((prev) => {

                            return {
                                ...prev,
                                filter: {
                                    ...prev.filter,
                                    [filterKey]: {
                                        value: value,
                                        primary: false, 
                                    }
                                }
                            };
                        });
                    }}
                    useTranslation
                    options={availableFilters}
                    selected={-1}
                    closeOnSelection
                    resetOnSelection
                >
                    {({anchorEl,onClick}) => (
                        <ButtonBase
                            onClick={onClick}
                            className={cx(undefined,{
                                'wrapped':props.wrapFilters
                            })}
                            sx={{
                                width:32,
                                height:32,
                                flexShrink:0,
                                borderRadius:4,
                                background:colors.txt["primary"],
                                color:theme.palette.mode === "dark" ? colors.txt["primaryDark"] : colors.txt["light"],
                                fontSize:14,
                                fontFamily:"Roboto,sans-serif",
                                fontWeight:500,
                                "@media screen and (max-width: 1024px)" : {
                                    ml:"auto",
                                },
                                "&.wrapped" : {
                                    width:1,
                                    justifyContent:'space-between',
                                    display:'flex',
                                    pr:1,
                                }
                            }}
                        >
                            {props.wrapFilters &&
                                <>
                                    <Box sx={{
                                        width:32,
                                    }}/>
                                    {t('add_filter')}
                                </>
                            }
                            <AddOutlinedIcon fontSize="small"/>
                        </ButtonBase>
                    )}
                </DropdownBaseV2>
            }
        
        </Box>
    )
}